import { CatalogProductType } from '../enums'
import { CatalogProduct } from '../types'
import { SpineModuleCatalogProduct } from '../types/CatalogProduct'
import { SpineModuleCatalogProductCustomDataInput } from '../types/CatalogProductInput'
import CatalogProductForm, { SpineConfigFields } from './CatalogProductForm'

export interface SpineModuleCatalogProductFormProps {
  catalogProduct?: SpineModuleCatalogProduct
  onCancel?: () => void
  onError?: (error: unknown) => void
  afterSubmit?: (catalogProduct: CatalogProduct) => void
}

export default function SpineModuleCatalogProductForm({
  catalogProduct,
  ...props
}: SpineModuleCatalogProductFormProps) {
  return (
    <CatalogProductForm
      {...props}
      type={CatalogProductType.SPINE_MODULE}
      catalogProduct={catalogProduct}
    />
  )
}

export function SpineModuleCatalogProductCustomDataFields({
  value,
  disabled = false,
  onChange
}: {
  value: SpineModuleCatalogProductCustomDataInput
  catalogProduct?: CatalogProduct
  disabled?: boolean
  isError?: (field: string) => boolean
  getHelperText?: (field: string) => string | undefined
  onChange: (value: SpineModuleCatalogProductCustomDataInput) => void
}) {
  return <SpineConfigFields value={value} disabled={disabled} onChange={onChange} />
}
